import React from 'react'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {useDispatch, useSelector} from 'react-redux'
import {
  gu_cu_ShowModalConfirmacion,
  gu_cu_ShowModalVerificacion,
} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {State} from '../../../../reducers'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'
import {bindActionCreators} from 'redux'

const ModalVerificacion = () => {
  const verifyCode = useSelector((state: State) => state.gestionUsuario.creacionUsuario.codeVerify)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)

  const regresar = async () => {
    await dispatch(gu_cu_ShowModalVerificacion(false))
    await dispatch(gu_cu_ShowModalConfirmacion(true))
  }

  const enviar = async (e: any) => {
    e.preventDefault()
    if (await actions.gu_cu_validacionesCodigoEnviar()) return
    actions.gu_cu_VerificarCodigoEmail()
  }
  return (
    <ModalBase
      Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#f1f1f1', padding: '2%'}}
    >
      <div className='form-content centrar-horizontal'>
        <h4 className='h4-titles'>Verificación</h4>
        <div>Se ha enviado un código de verificación a tu correo electrónico.</div>

        <form
          className='form-content'
          data-wf-page-id='64af244a307770eac998c0c4'
          data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
          onSubmit={enviar}
        >
          <div>
            <label htmlFor='idCode' className='field-label m'>
              Código
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field w-input'
              maxLength={20}
              autoFocus
              name='code'
              data-name=''
              placeholder='Código de verificación'
              id='idCode'
              value={verifyCode.code}
              onChange={actions.gu_cu_FormVerifyCodeHandleChange}
              onBlur={actions.gu_cu_validacionesCodigoOnBlur}
            />
            {verifyCode.error && <p className='alert s'>{verifyCode.error}</p>}
          </div>
          <div className='w-layout-hflex button-actions'>
            <button type='button' className='m button transparent w-inline-block' onClick={regresar}>
              Regresar
            </button>
            <button type='submit' className='m button w-inline-block'>
              Enviar
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  )
}

export default ModalVerificacion
